import React from "react";
import "./CtaButton.css";
import StyledLgText from "../../../common/components/styledLgText/StyledLgText";

const CtaButton = ({ children, fontColor, padding, onClick }) => {
  return (
    <div className="container w-full flex flex-wrap justify-around">
      <button
        onClick={onClick}
        className={`btn group relative left-0 top-0 m-0 flex justify-center items-center w-fit px-24 ${padding} h-[40px]`}
      >
        <span
          className={`absolute top-0 left-0 w-full h-full flex justify-center items-center rounded-md p-[10px] tracking-[1px] decoration-0 overflow-hidden text-white z-10 group-hover:text-black group-hover:font-semibold ${fontColor}`}
        >
          <StyledLgText>{children}</StyledLgText>
        </span>
      </button>
    </div>
  );
};

export default CtaButton;
